import { VCardTitle } from 'vuetify/lib/components/VCard';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('line-chart',{staticClass:"fill-height",attrs:{"raw-data":_vm.periods,"type":"bar","chart-value-keys":[
    { key: 'CAPGCSDCB13EG2', type: 'bar', label: _vm.$t('chart_legends.deceleration_less_-4') },
    { key: 'UXDCB13', type: 'bar', label: _vm.$t('chart_legends.deceleration_less_-3') },
    { key: 'UXDCB14', type: 'bar', label: _vm.$t('chart_legends.deceleration_less_-2') },
    { key: 'UXACB58', type: 'bar', label: _vm.$t('chart_legends.accelerations_more_2') },
    { key: 'UXACB68', type: 'bar', label: _vm.$t('chart_legends.accelerations_more_3') },
    { key: 'CAPGCSACB13EG2', type: 'bar', label: _vm.$t('chart_legends.accelerations_more_4') } ],"x-value":"title","y-value-prefix":"teams[0].team_stats.","xaxis":{
    labels: {
      rotate: -45
    },
    tickPlacement: 'between'
  },"stacked":true,"colors":[ '#ff0000', '#ff6666', '#ff9999', '#1affb2', '#00e396', '#00b377'],"fill":{ opacity: [1, 1, 1, 1, 1, 1]}},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c(VCardTitle,{staticClass:"pa-6 d-flex justify-space-between"},[_c('div',{staticClass:"subtitle-2 grey--text text--grey-100"},[_vm._v(" "+_vm._s(_vm.$t('card_title.accelerations_and_decelerations'))+" ")])])]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }